import { jsxs as o, jsx as i } from "react/jsx-runtime";
import "react";
import { p as n } from "../../index-B0ARwqly.mjs";
import '../../assets/InstructionsList.css';const s = {
  "instructions-list__list": "_instructions-list__list_suf45_1",
  "instructions-list__item": "_instructions-list__item_suf45_5"
};
function u({ headerHtml: t = "", instructions: r = [] }) {
  return /* @__PURE__ */ o("div", { className: [s["instructions-list"], "instructions-list"].join(" "), children: [
    t !== "" && /* @__PURE__ */ i("h3", { className: [s["instructions-list__header"], "instructions-list__header"].join(" "), children: n(t) }),
    /* @__PURE__ */ i("ol", { className: [s["instructions-list__list"], "instructions-list__list"].join(" "), children: r.map((l) => /* @__PURE__ */ i("li", { className: [s["instructions-list__item"], "instructions-list__item"].join(" "), children: n(l) }, `${Math.random() * 1e6}`)) })
  ] });
}
export {
  u as InstructionsList,
  u as default
};
